import Img, { FluidObject } from 'gatsby-image';
import { Icon, IconType } from 'lucid-components-react';
import React from 'react';

import logo from 'assets/svgs/LucidSoftwareLogo.svg';
// import prideLogo from 'assets/LucidPride_LucidLogo.jpg';
import Link from 'components/link/link';

import './top-hero-with-logo.scss';

interface Props {
  header?: string;
  subLink?: string;
  subText?: string;
  paragraph?: string;
  ctaText?: string;
  ctaLink?: string;
  rightImage?: string;
  rightImagePlayClick?: () => void;
  rightGatsbySizes?: FluidObject;
  rightVideoMp4?: string;
  rightVideoWebM?: string;
  small?: boolean;
}

const TopHeroWithLogo = ({
  header,
  subLink,
  subText,
  paragraph,
  ctaText,
  ctaLink,
  rightImage,
  rightImagePlayClick,
  rightGatsbySizes,
  rightVideoMp4,
  rightVideoWebM,
  small
}: Props) => {
  return (
    <section className={`homepage-hero ${small ? 'homepage-hero--small' : ''}`}>
      <div className="homepage-hero-title-container">
        <Link to="/">
          <img alt="Lucid Software Logo" className="top-logo" src={logo} />
        </Link>
        <h1>{header}</h1>
        {paragraph && (
          <p className="homepage-hero-paragraph callout-text">{paragraph}</p>
        )}
        {subText && subLink && (
          <div className="homepage-hero-subtext">
            <a
              className="homepage-hero-subtext-link"
              href={subLink}
              rel="noreferrer noopener"
              target="_blank"
            >
              {subText}
            </a>
          </div>
        )}
        {ctaLink && ctaText && (
          <Link className="primary button v2" to={ctaLink}>
            {ctaText}
            <span className="icon-triangle" />
          </Link>
        )}
      </div>
      <div className="homepage-hero-image-container">
        {rightImage && rightImagePlayClick && (
          <div
            className="homepage-hero-image-with-play"
            onClick={rightImagePlayClick}
            onKeyPress={rightImagePlayClick}
            role="button"
            tabIndex={0}
          >
            <img
              alt="Openings at Lucid"
              className="homepage-hero-image shady"
              src={rightImage}
            />
          </div>
        )}
        {rightImage && !rightImagePlayClick && (
          <div>
            <img
              alt="Openings at Lucid"
              className="homepage-hero-image shady"
              src={rightImage}
            />
          </div>
        )}
        {rightGatsbySizes && rightImagePlayClick && (
          <div
            className="homepage-hero-image-with-play"
            onClick={rightImagePlayClick}
            onKeyPress={rightImagePlayClick}
            role="button"
            tabIndex={0}
          >
            <Img
              alt="Openings at Lucid"
              className="homepage-hero-image shady"
              fadeIn={false}
              fluid={rightGatsbySizes}
            />
            <button className="homepage-hero-play-button">
              <Icon sizing="responsive" type={IconType.Play} />
            </button>
          </div>
        )}
        {rightGatsbySizes && !rightImagePlayClick && (
          <div
            style={{
              position: 'absolute',
              width: '900px',
              height: '900px'
            }}
          >
            <Img
              alt="Lucid"
              className="homepage-hero-image shady"
              fadeIn={false}
              fluid={rightGatsbySizes}
            />
          </div>
        )}
        {rightVideoMp4 && (
          <video
            autoPlay
            loop
            muted
            playsInline
            className="homepage-hero-image shady"
          >
            {rightVideoWebM && (
              <source src={rightVideoWebM} type="video/webm" />
            )}
            <source src={rightVideoMp4} type="video/mp4" />
          </video>
        )}
      </div>
    </section>
  );
};

export default TopHeroWithLogo;
